import { AnyFieldApi } from '@tanstack/react-form';

import { ErrorMessage } from '@/common/components/fieldset';

/**
 * A component that displays validation error messages for form fields.
 *
 * This component automatically handles the display logic for field errors,
 * only showing errors when the field has been touched and contains validation
 * errors. It uses the Catalyst ErrorMessage component for consistent styling.
 *
 * @param field - The TanStack Form field API instance
 *
 * @example
 * ```tsx
 * const field = useField({ name: 'email' });
 * return <FieldInfo field={field} />;
 * ```
 */
export function FieldInfo({ field }: { field: AnyFieldApi }) {
  if (!field.state.meta.isTouched || field.state.meta.isValid) {
    return null;
  }

  return (
    <ErrorMessage>
      {field.state.meta.errors.map((err: any) => err?.message).join(', ')}
    </ErrorMessage>
  );
}
